import styled from "styled-components";

export const LiveCasinoGridItemJackpotDefaultBox = styled.div`
    display: flex;
    box-sizing: border-box;
    padding: 0 1rem;
    align-items: center;
    color: ${props => props.theme.colors.brandSecondary};
    background: ${props => props.theme.colors.background};
    border: 1px solid ${props => props.theme.components.newLiveCasino.colors.gridItem.wrapperBorder};
    border-radius: 50px;
    font-size: 1.2em;

    @media ${({theme}) => theme.mediaQuery.sAndBelow} {
        line-height: 1;
        font-size: 1.1em;
    }
`;
